import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var WindowContext = /*#__PURE__*/React.createContext();

function WindowProvider(_ref) {
  var window = _ref.window,
      children = _ref.children;
  return ___EmotionJSX(WindowContext.Provider, {
    value: window
  }, children);
}

WindowProvider.propTypes = {
  window: PropTypes.object,
  children: PropTypes.node.isRequired
};
export default WindowProvider;